module.exports = __webpack_public_path__ + "static/media/location-pic2.e1609c9c.jpg";